/* eslint-disable babel/camelcase */
import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  container: {
    position: 'absolute',
    zIndex: 3,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  horizontal: {
    top: 18,
    padding: '0 22px'
  },
  vertical: {
    backgroundColor: 'white',
    boxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.1)',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 52,
    zIndex: 3
  },
  verticalScrollable: {},
  prev: {
    cursor: 'pointer',
    lineHeight: 0.78,
    userSelect: 'none',
    appearance: 'none',
    backgroundColor: 'white',
    border: '1px solid lightgrey',
    ':focus': {
      outline: 'none',
      borderColor: 'dimgrey',
      boxShadow: '0 0 5px dimgrey'
    },
    ':active': {
      outline: 'none',
      borderColor: 'dimgrey',
      boxShadow: '0 0 5px dimgrey'
    }
  },
  prev_horizontal: {
    borderRadius: 3,
    padding: 9
  },
  prev_vertical: {
    display: 'inline-block',
    position: 'relative',
    height: '100%',
    width: '50%',
    textAlign: 'center',
    fontSize: '1.25em',
    padding: 5
  },
  prev_verticalScrollable: {
    display: 'none'
  },
  next: {
    cursor: 'pointer',
    lineHeight: 0.78,
    userSelect: 'none',
    appearance: 'none',
    backgroundColor: 'white',
    border: '1px solid lightgrey',
    ':focus': {
      outline: 'none',
      borderColor: 'dimgrey',
      boxShadow: '0 0 5px dimgrey'
    },
    ':active': {
      outline: 'none',
      borderColor: 'dimgrey',
      boxShadow: '0 0 5px dimgrey'
    }
  },
  next_horizontal: {
    borderRadius: 3,
    padding: 9
  },
  next_vertical: {
    display: 'inline-block',
    position: 'relative',
    height: '100%',
    width: '50%',
    textAlign: 'center',
    fontSize: '1.25em',
    padding: 5,
    borderLeft: 0
  },
  next_verticalScrollable: {
    width: '100%'
  },
  rtl: {
    flexDirection: 'row-reverse'
  }
});